module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image-t"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/8.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "chapter-no",
    attrs: {
      "id": "ch-1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("SYRIAC")]), _vm._v(" "), _c('h1', {
    staticClass: "chapter-author"
  }, [_vm._v("Introduction and Bibliography by J. Edward Walters")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "dropcap1"
  }, [_vm._v("T")]), _vm._v("raveling east and slightly north from Syrian Antioch, ancient travelers would have come to the magnificent city of Edessa in the kingdom of Osroene, which occupied a strategic location on the Roman-Parthian (and later Roman-Sassanian Persian) border."), _c('a', {
    attrs: {
      "href": "#/#foot_1",
      "id": "foot-1"
    }
  }, [_c('sup', [_vm._v("1")])]), _vm._v(" Edessa was a cosmopolitan city, located along a major east-west trade route, and well known as a home to many gods and the diverse peoples who were devoted to them."), _c('a', {
    attrs: {
      "href": "#/#foot_2",
      "id": "foot-2"
    }
  }, [_c('sup', [_vm._v("2")])]), _vm._v(" Although the sources are difficult to trust as straightforward records, it seems that Edessa served as a gateway for early Christian expansion to the east."), _c('a', {
    attrs: {
      "href": "#/#foot_3",
      "id": "foot-3"
    }
  }, [_c('sup', [_vm._v("3")])]), _vm._v(" Edessa was also the home of the dialect of Aramaic known as Syriac, which would become the primary literary language for Christianity in Mesopotamia for several centuries."), _c('a', {
    attrs: {
      "href": "#/#foot_4",
      "id": "foot-4"
    }
  }, [_c('sup', [_vm._v("4")])]), _vm._v(" Further to the east, not far from Edessa lay the city of Nisibis, an ancient fortified city that is perhaps most well known as a territory lost by the Roman Empire in the aftermath of the defeat and death of Emperor Julian at the Battle of Samarra in 363 CE. As a result of the treaty signed by Julian’s successor, Jovian, the Persian King Shapur II, who had failed on three previous siege attempts against Nisibis, took control of the city without having to destroy its walls, while the Christian community in Nisibis was forced to relocate across the Roman border, namely back to cities like Amida and Edessa."), _c('a', {
    attrs: {
      "href": "#/#foot_5",
      "id": "foot-5"
    }
  }, [_c('sup', [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Among those Christians who were exiled from Nisibis was a theologian and poet who would come to be known as Ephrem the Syrian."), _c('a', {
    attrs: {
      "href": "#/#foot_6",
      "id": "foot-6"
    }
  }, [_c('sup', [_vm._v("6")])]), _vm._v(" Ephrem’s influence on the Syriac traditions of Christianity cannot be overstated. His theology permeates the Syriac liturgies, and his unique expressions and turns of phrase are echoed throughout later Syriac authors. His signature composition style, a metrical structure known as a "), _c('em', [_vm._v("madrāšā")]), _vm._v(" (frequently translated “hymn” but perhaps more accurately rendered “teaching song”), became a standard genre of Syriac literature."), _c('a', {
    attrs: {
      "href": "#/#foot_7",
      "id": "foot-7"
    }
  }, [_c('sup', [_vm._v("7")])]), _vm._v(" In both prose and poetic compositions, Ephrem is also one of the most significant Syriac sources for three teachers who would ultimately come to be regarded as heretics by Christians, but who also had significant communities of followers in Ephrem’s time: Bardaisan, Marcion, and Mani."), _c('a', {
    attrs: {
      "href": "#/#foot_8",
      "id": "foot-8"
    }
  }, [_c('sup', [_vm._v("8")])]), _vm._v(" These texts serve as valuable witnesses—albeit one-sided, polemical witnesses—to the beliefs and practices of these communities in the fourth century.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ephrem also had a significant impact on the development of biblical exegesis in the Syriac tradition, as his poetic teaching songs displayed a unique creativity with interpretation, sometimes in the form of invented dialogue for biblical characters."), _c('a', {
    attrs: {
      "href": "#/#foot_9",
      "id": "foot-9"
    }
  }, [_c('sup', [_vm._v("9")])]), _vm._v(" This style of poetic exegesis allowed Syriac authors to creatively embody characters, often giving voice to figures—especially women—who are relegated to silence in the biblical text itself."), _c('a', {
    attrs: {
      "href": "#/#foot_10",
      "id": "foot-10"
    }
  }, [_c('sup', [_vm._v("10")])]), _vm._v(" It is also likely that at least some of these poems were performed by women in liturgical settings."), _c('a', {
    attrs: {
      "href": "#/#foot_11",
      "id": "foot-11"
    }
  }, [_c('sup', [_vm._v("11")])]), _vm._v(" Later Syriac authors also continued to develop their own form of poetic meter for biblical interpretation and homilies. In particular we may mention authors like Jacob of Serugh and Narsai of Nisibis, who each perfected the syllabic homily for their own exegetical purposes. Although his name is certainly not commonly known among historians of Christianity, it is estimated that Jacob of Serugh has the third largest surviving corpus of homilies from early Christianity across all languages, behind only John Chrysostom and Augustine of Hippo."), _c('a', {
    attrs: {
      "href": "#/#foot_12",
      "id": "foot-12"
    }
  }, [_c('sup', [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("These two authors, Jacob and Narsai, are notable for another reason: though their careers overlap, they represent two distinct emerging traditions of Syriac Christianity that put them on opposite sides of a significant theological dispute that forever altered the ecclesiastical context for Syriac Christians. The impetus for this change was, of course, the christological disputes set off by Nestorius, the bishop of Constantinople, who infamously argued that Mary, the mother of Jesus, should not bear the title "), _c('em', [_vm._v("theotokos")]), _vm._v(" (“God-bearer” or “Mother of God”) because, according to Nestorius, such a title unnecessarily collapsed and confused the divine and human natures of Christ. Nestorius soon found himself the object of significant backlash, led by Cyril of Alexandria. The resulting controversy spawned not one, but two councils: the Council of Ephesus (431) and the Council of Chalcedon (451). It would be impossible to summarize these complicated events in this short introduction, but the following points are pertinent to Syriac Christianity."), _c('a', {
    attrs: {
      "href": "#/#foot_13",
      "id": "foot-13"
    }
  }, [_c('sup', [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The key issue at stake in the two councils was the question of the human and divine natures of Christ and what language was appropriate for describing them. One side of the debate, represented by Nestorius and his deceased teacher, Theodore of Mopsuestia, argued that Jesus’s human and divine natures remained distinct (and thus they were called dyophysites, meaning “two natures”)."), _c('a', {
    attrs: {
      "href": "#/#foot_14",
      "id": "foot-14"
    }
  }, [_c('sup', [_vm._v("14")])]), _vm._v(" The other side, represented by Cyril of Alexandria and his supporters, argued that it was heretical to distinguish too sharply between the natures because it implied not just two natures, but two “persons” in Christ. The theological statement produced by the Council of Chalcedon attempted to resolve this issue with a conciliatory position that Christ is “acknowledged in two natures … in one person and one hypostasis.”"), _c('a', {
    attrs: {
      "href": "#/#foot_15",
      "id": "foot-15"
    }
  }, [_c('sup', [_vm._v("15")])]), _vm._v(" While the ratification of this formulation at the council did succeed in giving Christians a new theological articulation, it failed to convince everyone. In fact, not only did the new statement not pacify the dyophysites who were loyal to Theodore and Nestorius, it also sparked a reaction from the opposite end of the spectrum: the miaphysites, who argued that the “in two natures” language of the Chalcedonian formula misrepresented the Christology of Cyril of Alexandria (who had died in 444, several years before the council). The miaphysite position argued, contra both Nestorian dyophysites and Chalcedonian dyophysites, that the union of divine and human natures in the incarnate Christ did not permit anyone to speak of them as distinctly two natures in the person of Christ; thus, they argued for one united nature after the incarnation (subsequently they were called miaphysites, meaning “one nature”)."), _c('a', {
    attrs: {
      "href": "#/#foot_16",
      "id": "foot-16"
    }
  }, [_c('sup', [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Thus, in the aftermath of the Council of Chalcedon, there were three distinct confessions: (1) those who supported and affirmed Chalcedon, primarily made up of Christians within the bounds of the Roman Empire, (2) the non-Chalcedonian dyophysites (who are often called “Nestorians”), who were primarily located in Persia, and (3) the miaphysites, who were concentrated in the eastern Mediterranean, stretching from Egypt, through Syria, and into Armenia. Throughout the sixth century, these distinct theological positions hardened in opposition to each other, forming distinct communities of Christians with separate leadership and hierarchical structure. Thus the end result of this controversy was the origin of several unique Christian church organizations that were not in communion with one another: (1) the Chalcedonians (who would separate later into the Byzantine Greek Orthodox and Roman Catholic traditions), distinguished by the affirmation of the Council of Chalcedon, (2) the Assyrian Church of the East (the non-Chalcedonian dyophysites), and (3) the various miaphysite confessions that formed among linguistically diverse communities: Syriac Orthodox Church, Armenian Orthodox Church, Coptic Orthodox Church, and Ethiopian Orthodox Church. Thus, after the fifth century, Syriac authors are universally designated by which tradition they represent: West Syriac (Syriac Orthodox), East Syriac (Assyrian Church of the East), or Melkite (i.e., the Syriac and later Arabic speakers who supported Chalcedon)."), _c('a', {
    attrs: {
      "href": "#/#foot_17",
      "id": "foot-17"
    }
  }, [_c('sup', [_vm._v("17")])]), _vm._v(" Mention should also be made of the Maronite tradition, which is another branch of early Syriac Christianity distinct from the East and West Syriac churches who remained in communion with the Chalcedonian tradition. Maronites remain as a distinct tradition today, concentrated in Lebanon."), _c('a', {
    attrs: {
      "href": "#/#foot_18",
      "id": "foot-18"
    }
  }, [_c('sup', [_vm._v("18")])]), _vm._v(" As time went on, there were further geographic and theological fragmentations of these branches.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The geographic dispersion of Syriac-speaking Christians meant that individual communities faced very different political situations, even at contemporaneous times. For example, while Christians in the Roman Empire enjoyed the ascendance of Christian political power with Constantine and his successors, Christians in the Sassanian Empire remained a religious minority who were often at odds with their political leaders. As a result of these circumstances, the martyrdom genre became a significant feature of Syriac literature, resulting in a sizable corpus known as the "), _c('em', [_vm._v("Persian Martyr Acts")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#foot_19",
      "id": "foot-19"
    }
  }, [_c('sup', [_vm._v("19")])]), _vm._v(" Historians of Christianity are likely very familiar with the persecutions associated with the Roman Emperors Decius and Diocletian, but comparatively far less is known about the persecution associated with Shapur II or Yazdagird I."), _c('a', {
    attrs: {
      "href": "#/#foot_20",
      "id": "foot-20"
    }
  }, [_c('sup', [_vm._v("20")])]), _vm._v(" At the same time, it is also important to remember that there were Syriac-speaking Christians "), _c('em', [_vm._v("within")]), _vm._v(" the Roman Empire, as evidenced both by the existence of the Melkite tradition mentioned above and by many miaphysite Christians finding themselves persecuted as heretics by their own emperor, Justinian."), _c('a', {
    attrs: {
      "href": "#/#foot_21",
      "id": "foot-21"
    }
  }, [_c('sup', [_vm._v("21")])]), _vm._v(" It is often tempting to collapse “Syriac Christianity” with something foreign to the context of the Roman Empire, but this erases communities who existed as both Romans and Syriac Christians. Moreover, as seen in the "), _c('em', [_vm._v("Letter on the")]), _vm._v(" "), _c('span', {
    staticClass: "f1"
  }, [_vm._v("Ḥ")]), _c('em', [_vm._v("imyarite Martyrs")]), _vm._v(" (translated in this volume), Syriac-speaking Christians well beyond the borders of the Roman and Persian Empires were involved in geopolitical schemes that ultimately resulted in persecution and death. Despite these trying political situations, Christianity flourished in the Sassanian Empire and beyond, as communities spread and episcopal sees proliferated."), _c('a', {
    attrs: {
      "href": "#/#foot_22",
      "id": "foot-22"
    }
  }, [_c('sup', [_vm._v("22")])]), _vm._v(" For example, despite a narrative of antagonism with the Sassanian rulers, Seleucia-Ctesiphon, the Sassanian capital, became a significant episcopal see, ultimately serving as the seat of the catholicos of the Church of the East"), _c('a', {
    attrs: {
      "href": "#/#foot_23",
      "id": "foot-23"
    }
  }, [_c('sup', [_vm._v("23")])]), _vm._v(" and the site of the earliest known synod of the Syriac tradition, the Synod of Is"), _c('span', {
    staticClass: "f2"
  }, [_vm._v("ḥ")]), _vm._v("aq (410).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As evidence of their continued flourishing, Christians found a place in the royal courts of the Sassanians, the Umayyads, and the Abbasids, and they came to play a pivotal role in the translation of texts from Greek and Syriac into Arabic."), _c('a', {
    attrs: {
      "href": "#/#foot_24",
      "id": "foot-24"
    }
  }, [_c('sup', [_vm._v("24")])]), _vm._v(" And, while the Muslim caliphates conquered the lands of the Sassanian Empire, while Islam uprooted Zoroastrianism, and while Arabic slowly but surely replaced other regional languages, Syriac-speaking Christians retained many of their distinct practices, including the use of Syriac as a liturgical language."), _c('a', {
    attrs: {
      "href": "#/#foot_25",
      "id": "foot-25"
    }
  }, [_c('sup', [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In addition to sociopolitical and theological divisions, Syriac Christians also came to define themselves over and against religious others as well: Jews, pagans (i.e., adherents of traditional and local gods in various places), Manicheans, Zoroastrians, and—ultimately—Muslims. It is not surprising, then, that these other religious communities occupy a constant place in Syriac Christian literature, both as foils and as real theological opponents."), _c('a', {
    attrs: {
      "href": "#/#foot_26",
      "id": "foot-26"
    }
  }, [_c('sup', [_vm._v("26")])]), _vm._v(" The eradication of paganism and destruction of pagan temples plays an important role in origin stories for Syriac Christianity, such as the "), _c('em', [_vm._v("Doctrina Addai")]), _vm._v(", and anti-Jewish rhetoric shows up throughout many forms of Syriac literature, including the "), _c('em', [_vm._v("Letter on the")]), _vm._v(" "), _c('span', {
    staticClass: "f1"
  }, [_vm._v("Ḥ")]), _c('em', [_vm._v("imyarite Martyrs")]), _vm._v(", in which a Jewish king sets off a persecution of Christians within his kingdom. It is also not surprising that, following the advent of Islam, Syriac Christians produced a rather large corpus of writings that explicitly discusses Islamic theology and Christian-Muslim relations."), _c('a', {
    attrs: {
      "href": "#/#foot_27",
      "id": "foot-27"
    }
  }, [_c('sup', [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Syriac Christians also produced a large body of ascetic and hagiographic literature. In the earliest period of Syriac Christianity, a unique expression of asceticism arose that was not directly influenced by the Egyptian monastic movement."), _c('a', {
    attrs: {
      "href": "#/#foot_28",
      "id": "foot-28"
    }
  }, [_c('sup', [_vm._v("28")])]), _vm._v(" Even by the time of one of the earliest surviving Syriac corpuses, the "), _c('em', [_vm._v("Demonstrations")]), _vm._v(" attributed to Aphraha"), _c('span', {
    staticClass: "f2"
  }, [_vm._v("ṭ")]), _vm._v(" the Persian sage (dated 337–45 CE), there is already an established group of ascetics known as the "), _c('em', [_vm._v("bnāy qyāmā")]), _vm._v(", the “children of the covenant.”"), _c('a', {
    attrs: {
      "href": "#/#foot_29",
      "id": "foot-29"
    }
  }, [_c('sup', [_vm._v("29")])]), _vm._v(" These ascetics, unlike their Egyptian contemporaries, were not removed from society and living as hermits in remote locations; rather, it seems that they lived alongside other lay Christians and were distinguished only by their rigid practices of denial, namely virginity."), _c('a', {
    attrs: {
      "href": "#/#foot_30",
      "id": "foot-30"
    }
  }, [_c('sup', [_vm._v("30")])]), _vm._v(" By the fifth century, writings from the Egyptian and Greek monastic contexts had begun to be translated into Syriac, which influenced both the practices and literature of Syriac ascetic communities, including the proliferation of hagiographic lives, many of which exist in Syriac as translations from Greek"), _c('a', {
    attrs: {
      "href": "#/#foot_31",
      "id": "foot-31"
    }
  }, [_c('sup', [_vm._v("31")])]), _vm._v(" or as native Syriac compositions. Regardless of language of origin, though, it is clear from the size of the surviving corpus in Syriac that hagiographies and devotion to saints came to be a particularly significant expression of piety in the Syriac context."), _c('a', {
    attrs: {
      "href": "#/#foot_32",
      "id": "foot-32"
    }
  }, [_c('sup', [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The topic of translations of Greek writings is also significant for the issue of the transmission and reception of biblical writings in Syriac. The Gospels were likely one of the earliest corpuses to be translated from Greek to Syriac, which is all the more significant given that there were at least three distinct versions of the Gospels in Syriac by the fourth century: (1) the Diatessaron of Tatian, (2) the “Old Syriac Gospels,” and (3) the Peshi"), _c('span', {
    staticClass: "f2"
  }, [_vm._v("ṭ")]), _vm._v("ta."), _c('a', {
    attrs: {
      "href": "#/#foot_33",
      "id": "foot-33"
    }
  }, [_c('sup', [_vm._v("33")])]), _vm._v(" The last of these, the Peshi"), _c('span', {
    staticClass: "f2"
  }, [_vm._v("ṭ")]), _vm._v("ta, became the authoritative version of the Bible over the course of the fourth and fifth centuries,"), _c('a', {
    attrs: {
      "href": "#/#foot_34",
      "id": "foot-34"
    }
  }, [_c('sup', [_vm._v("34")])]), _vm._v(" despite the Peshi"), _c('span', {
    staticClass: "f2"
  }, [_vm._v("ṭ")]), _vm._v("ta New Testament lacking several books that had come to be accepted in the Greek canon: 2 Peter, 2–3 John, Jude, and Revelation. These latter books were later translated into Syriac, likely in the sixth century, as part of a broader Greek-to-Syriac translation movement, and they ultimately came to circulate as part of Syriac biblical manuscripts."), _c('a', {
    attrs: {
      "href": "#/#foot_35",
      "id": "foot-35"
    }
  }, [_c('sup', [_vm._v("35")])]), _vm._v(" As Greek translations into Syriac increased in the fifth and sixth centuries, attitudes with respect to translation theory and practice also shifted,"), _c('a', {
    attrs: {
      "href": "#/#foot_36",
      "id": "foot-36"
    }
  }, [_c('sup', [_vm._v("36")])]), _vm._v(" resulting in yet two more Syriac New Testament translation projects: the Philoxenian revision and the Harklean version."), _c('a', {
    attrs: {
      "href": "#/#foot_37",
      "id": "foot-37"
    }
  }, [_c('sup', [_vm._v("37")])]), _vm._v(" The latter of these, named after its translator, Thomas of Harkel, is a hyper-literal translation that attempts, as much as possible, to render a word-for-word Syriac translation of the Greek New Testament. And there were many other translations of biblical and parabiblical materials as well. There is a significant body of apocryphal literature in Syriac,"), _c('a', {
    attrs: {
      "href": "#/#foot_38",
      "id": "foot-38"
    }
  }, [_c('sup', [_vm._v("38")])]), _vm._v(" including some works that exist only in Syriac and Arabic translations, such as "), _c('em', [_vm._v("2 Baruch")]), _vm._v(" (also known as the "), _c('em', [_vm._v("Syriac Apocalypse of Baruch")]), _vm._v(") and "), _c('em', [_vm._v("4 Ezra")]), _vm._v(", and other works for which the Syriac text is a significant textual witness, such as the "), _c('em', [_vm._v("Infancy Gospel of Thomas")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#foot_39",
      "id": "foot-39"
    }
  }, [_c('sup', [_vm._v("39")])]), _vm._v(" The Septuagint column of Origen’s Hexapla was also translated into Syriac, known as the Syro-Hexapla, and this version remains one of the most important witnesses to Origen’s monumental work."), _c('a', {
    attrs: {
      "href": "#/#foot_40",
      "id": "foot-40"
    }
  }, [_c('sup', [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The genres and titles mentioned above comprise a significant percentage of surviving Syriac works, yet even these works scarcely scratch the surface of surviving Syriac literature, which also includes translations of important classical works of philosophy, medicine, science, historical works and chronicles, patristic writings (both translated and native Syriac), grammars and linguistic resources, and a vast body of liturgical materials that testifies to Syriac enduring (even today) as, primarily, a liturgical language. The Syriac literary culture also continued to thrive throughout the medieval period. Indeed, some scholars refer to the eleventh–thirteenth centuries as a period of renaissance for the Syriac tradition."), _c('a', {
    attrs: {
      "href": "#/#foot_41",
      "id": "foot-41"
    }
  }, [_c('sup', [_vm._v("41")])]), _vm._v(" Two particularly important and prolific authors from this period are worth mentioning for their significant contributions to the Syriac tradition: Patriarch Michael the Great and Gregory Bar "), _c('span', {
    staticClass: "f2"
  }, [_vm._v("ʿ")]), _vm._v("Ebroyo."), _c('a', {
    attrs: {
      "href": "#/#foot_42",
      "id": "foot-42"
    }
  }, [_c('sup', [_vm._v("42")])]), _vm._v(" Michael wrote a monumental historical work that incorporates excerpts of many earlier historical works in Syriac, some of which have not survived otherwise,"), _c('a', {
    attrs: {
      "href": "#/#foot_43",
      "id": "foot-43"
    }
  }, [_c('sup', [_vm._v("43")])]), _vm._v(" and Bar "), _c('span', {
    staticClass: "f2"
  }, [_vm._v("ʿ")]), _vm._v("Ebroyo is the author of dozens of works of theology, philosophy, grammar, and history."), _c('a', {
    attrs: {
      "href": "#/#foot_44",
      "id": "foot-44"
    }
  }, [_c('sup', [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The vast majority of Syriac literature was copied and preserved at Syriac monasteries and churches. Many Syriac ecclesiastical leaders were educated at monastic schools, such as the School of Edessa, which was shut down in 489 CE by the Roman emperor Zeno,"), _c('a', {
    attrs: {
      "href": "#/#foot_45",
      "id": "foot-45"
    }
  }, [_c('sup', [_vm._v("45")])]), _vm._v(" and subsequently the School of Nisibis, founded by Narsai."), _c('a', {
    attrs: {
      "href": "#/#foot_46",
      "id": "foot-46"
    }
  }, [_c('sup', [_vm._v("46")])]), _vm._v(" Beyond this school environment, the study and preservation of Syriac texts took place primarily within the monasteries. Thousands of Syriac manuscripts, dated from the fifth century all the way to the twentieth century, survive, testifying to an active scribal and literary culture. In the West Syriac tradition, the region of Tur "), _c('span', {
    staticClass: "f2"
  }, [_vm._v("ʿ")]), _vm._v("Abdin (near Mardin, Turkey) was home to many monasteries, including the famous Dayr al-Zafaran, longtime residence of the Syriac Orthodox patriarchate. The cluster of monasteries in Tur "), _c('span', {
    staticClass: "f2"
  }, [_vm._v("ʿ")]), _vm._v("Abdin became a hub of manuscript copying and preservation. In the East Syriac tradition, monasteries in Mosul, Karka d-Beth Slok (Kirkuk), and Alqosh became important sites of manuscript production."), _c('a', {
    attrs: {
      "href": "#/#foot_47",
      "id": "foot-47"
    }
  }, [_c('sup', [_vm._v("47")])]), _vm._v(" It should also be noted that there are a significant number of early Syriac manuscripts that were preserved at the Deir al-Surian monastery in Egypt, thanks in large part to an industrious monk named Mushē of Nisibis, who traveled through Mesopotamia, purchased and collected manuscripts, and brought them back to Egypt."), _c('a', {
    attrs: {
      "href": "#/#foot_48",
      "id": "foot-48"
    }
  }, [_c('sup', [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As a final point, it is worth reflecting on the state of Syriac Christianity as a living heritage, divided as it is across multiple confessional identities. To begin with, the three early branches of Syriac Christianity that have their origins in the fifth century still remain to this day in the form of the Maronite Church, the Assyrian Church of the East, and the Syriac Orthodox Church. The latter two traditions, however, also have multiple offshoots, which can be quite confusing. First, it is significant to note that East Syriac Christian missionaries took Christian teachings along the Silk Road as far as India and China at least as early as the sixth century, if indeed not much earlier."), _c('a', {
    attrs: {
      "href": "#/#foot_49",
      "id": "foot-49"
    }
  }, [_c('sup', [_vm._v("49")])]), _vm._v(" Although Syriac Christianity persisted in China until it was expelled in the fourteenth century, it took root and thrived in India under the authority of the Assyrian Church of the East. Following the arrival of Jesuit missionaries in the early modern period, though, the picture of Syriac Christianity in India is much more complex, with multiple splits and newly formed organizations (often with overlapping names) who practice distinct rites."), _c('a', {
    attrs: {
      "href": "#/#foot_50",
      "id": "foot-50"
    }
  }, [_c('sup', [_vm._v("50")])]), _vm._v(" Catholic missionary activity in the early modern Middle East also produced a number of changes in Syriac ecclesiastical organization, most notably the creation of the Chaldean Catholic Church (which split from the Assyrian Church of the East and joined in communion with the Roman Catholic Church) and the Syriac Catholic Church (which split from the Syriac Orthodox Church and joined in communion with the Roman Catholic Church). Finally, it is worth noting that primarily because of the turbulent events of the early twentieth century in Turkey and Armenia, known in Syriac as the "), _c('em', [_vm._v("Sayfo")]), _vm._v(" (“the sword”),"), _c('a', {
    attrs: {
      "href": "#/#foot_51",
      "id": "foot-51"
    }
  }, [_c('sup', [_vm._v("51")])]), _vm._v(" significant diaspora communities of Syriac heritage are spread around the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Syriac traditions of Christianity are diverse and vibrant witnesses to the ways that Christianity has adapted to different circumstances throughout time. Syriac literature is rich and expansive, and the following translated texts provide only a cursory introduction to the Syriac heritage. The bibliography below will hopefully provide interested readers with more resources for further study.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2a",
    attrs: {
      "id": "sec2-7"
    }
  }, [_vm._v("Bibliography")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Barsoum, Ignatius Afram. "), _c('em', [_vm._v("The Scattered Pearls: A History of Syriac Literature and Sciences")]), _vm._v(". Translated by Matti Moosa. 2nd rev. ed. Piscataway, NJ: Gorgias, 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Baumstark, Anton. "), _c('em', [_vm._v("Geschichte der syrischen Literatur, mit Ausschluss der christlich-palästinensischen Texte.")]), _vm._v(" Bonn: Marcus & Webers, 1922.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Becker, Adam H. "), _c('em', [_vm._v("Fear of God and the Beginning of Wisdom: The School of Nisibis and Christian Scholastic Culture in Late Antique Mesopotamia.")]), _vm._v(" Philadelphia: University of Pennsylvania Press, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Beggiani, Seely. "), _c('em', [_vm._v("Early Syriac Theology, with Special Reference to the Maronite Tradition")]), _vm._v(". Rev. ed. Washington, DC: Catholic University of America Press, 2014.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Briquel-Chatonnet, Françoise, and Muriel Debié. "), _c('em', [_vm._v("Le monde syriaque: Sur les routes d’un christianisme ignoré")]), _vm._v(". Paris: Les Belles Lettres, 2017.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Brock, Sebastian P. "), _c('em', [_vm._v("The Bible in the Syriac Tradition")]), _vm._v(". Gorgias Handbooks 7. Piscataway, NJ: Gorgias, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("———. "), _c('em', [_vm._v("A Brief Outline of Syriac Literature")]), _vm._v(". Kottayam, India: Saint Ephrem Ecumenical Research Institute, 1987.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("———. "), _c('em', [_vm._v("Fire from Heaven: Studies in Syriac Theology and Liturgy.")]), _vm._v(" London: Variorum, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("———. "), _c('em', [_vm._v("An Introduction to Syriac Studies")]), _vm._v(". 3rd ed. Piscataway, NJ: Gorgias, 2017.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("———. "), _c('em', [_vm._v("The Luminous Eye: The Spiritual World Vision of Saint Ephrem the Syrian.")]), _vm._v(" Collegeville, MN: Cistercian, 1992.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("———. "), _c('em', [_vm._v("Studies in Syriac Christianity: History, Literature, and Theology.")]), _vm._v(" Aldershot: Variorum, 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("———. "), _c('em', [_vm._v("The Syriac Fathers on Prayer and the Spiritual Life.")]), _vm._v(" Collegeville, MN: Cistercian, 1987.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("———. "), _c('em', [_vm._v("Syriac Perspectives on Late Antiquity")]), _vm._v(". Aldershot: Variorum, 1984.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Brock, Sebastian P., Aaron M. Butts, George A. Kiraz, and Lucas Van Rompay, eds. "), _c('em', [_vm._v("The Gorgias Encyclopedic Dictionary of the Syriac Heritage")]), _vm._v(". Piscataway, NJ: Gorgias, 2011 (online at "), _c('a', {
    attrs: {
      "href": "https://gedsh.bethmardutho.org",
      "target": "_blank"
    }
  }, [_vm._v("https://gedsh.bethmardutho.org")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Brock, Sebastian P., and Susan Ashbrook Harvey. "), _c('em', [_vm._v("Holy Women of the Syrian Orient")]), _vm._v(". Rev. ed. Berkeley: University of California Press, 1987.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Butts, Aaron M. "), _c('em', [_vm._v("Language Change in the Wake of Empire: Syriac in Its Greco-Roman Context.")]), _vm._v(" Winona Lake, IN: Eisenbrauns, 2016.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Butts, Aaron M., and Simcha Gross. "), _c('em', [_vm._v("Jews and Syriac Christians: Intersections across the First Millennium")]), _vm._v(". Texts and Studies in Ancient Judaism 180. Tübingen: Mohr Siebeck, 2020.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Carlson, Thomas A. "), _c('em', [_vm._v("Christianity in Fifteenth-Century Iraq")]), _vm._v(". Cambridge: Cambridge University Press, 2018.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Doerfler, Maria, Emanuel Fiano, and Kyle Smith, eds. "), _c('em', [_vm._v("Syriac Encounters: Papers from the Sixth North American Syriac Symposium, Duke University, 26–29 June 2011")]), _vm._v(". Eastern Christian Studies 20. Leuven: Peeters, 2015.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Fiey, J.-M. "), _c('em', [_vm._v("Jalons pour une histoire de l’église en Iraq")]), _vm._v(". CSCO 310. Leuven: Secrétariat du CSCO, 1970.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Griffith, Sidney H. "), _c('em', [_vm._v("The Church in the Shadow of the Mosque: Christians and Muslims in the World of Islam.")]), _vm._v(" Princeton: Princeton University Press, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Harvey, Susan Ashbrook. "), _c('em', [_vm._v("Asceticism and Society in Crisis: John of Ephesus and the Lives of the Eastern Saints.")]), _vm._v(" Berkeley: University of California Press, 1990.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("———. “Theodora the ‘Believing Queen’: A Study in Syriac Historiographical Tradition.” "), _c('em', [_vm._v("Hugoye: Journal of Syriac Studies")]), _vm._v(" 4 (2001): 209–34.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Heal, Kristian S. “Catalogues and the Poetics of Syriac Manuscript Cultures.” "), _c('em', [_vm._v("Hugoye: Journal of Syriac Studies")]), _vm._v(" 20 (2017): 375–417.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("———. “Corpora, eLibraries, and Databases: Locating Syriac Studies in the 21st Century.” "), _c('em', [_vm._v("Hugoye: Journal of Syriac Studies")]), _vm._v(" 15 (2012): 65–78.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Healey, John F. “The Edessan Milieu and the Birth of Syriac.” "), _c('em', [_vm._v("Hugoye: Journal of Syriac Studies")]), _vm._v(" 10 (2011): 115–27.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("King, Daniel, ed. "), _c('em', [_vm._v("The Syriac World")]), _vm._v(". London: Routledge, 2019.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Kiraz, George A. "), _c('em', [_vm._v("Malphono w-Rabo d-Malphone: Studies in Honor of Sebastian P. Brock.")]), _vm._v(" Piscataway, NJ: Gorgias, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Labourt, J. "), _c('em', [_vm._v("Le christianisme dans l’empire perse sous la dynastie Sassanide (224–632).")]), _vm._v(" Paris: Lecoffre, 1904.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("McVey, Kathleen. "), _c('em', [_vm._v("Ephrem the Syrian: Hymns")]), _vm._v(". New York: Paulist, 1989.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Mellon Saint-Laurent, Jeanne-Nicole. "), _c('em', [_vm._v("Missionary Stories and the Formation of the Syriac Churches")]), _vm._v(". Oakland: University of California Press, 2015.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Murray, Robert. "), _c('em', [_vm._v("Symbols of Church and Kingdom: A Study in Early Syriac Tradition.")]), _vm._v(" Rev. ed. London: T&T Clark, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Murre-van den Berg, Heleen. “Generous Devotion: Women in the Church of the East between 1550 and 1850.” "), _c('em', [_vm._v("Hugoye: Journal of Syriac Studies")]), _vm._v(" 7 (2007): 11–54.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("———. "), _c('em', [_vm._v("Scribes and Scriptures: The Church of the East in the Eastern Ottoman Provinces (1500–1850).")]), _vm._v(" Eastern Christian Studies 21. Leuven: Peeters, 2015.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("———. “Syriac Christianity.” Pages 249–68 in "), _c('em', [_vm._v("The Blackwell Companion to Eastern Christianity")]), _vm._v(". Edited by Ken Parry. Oxford: Blackwell, 2017.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Payne, Richard E. "), _c('em', [_vm._v("A State of Mixture: Christians, Zoroastrians, and Iranian Political Culture in Late Antiquity.")]), _vm._v(" Oakland: University of California Press, 2015.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Penn, Philip Michael. "), _c('em', [_vm._v("Envisioning Islam: Syriac Christians and the Early Muslim World")]), _vm._v(". Philadelphia: University of Pennsylvania Press, 2017.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("———. "), _c('em', [_vm._v("When Christians First Met Muslims: A Sourcebook of the Earliest Syriac Writings on Islam.")]), _vm._v(" Oakland: University of California Press, 2015.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Possekel, Ute. "), _c('em', [_vm._v("Evidence of Greek Philosophical Concepts in the Writings of Ephrem the Syrian.")]), _vm._v(" CSCO 380. Leuven: Secrétariat du CSCO, 1999.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Shepardson, Christine. "), _c('em', [_vm._v("Anti-Judaism and Christian Orthodoxy: Ephrem’s Hymns in Fourth-Century Syria")]), _vm._v(". Washington, DC: Catholic University of America Press, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Smith, Kyle. "), _c('em', [_vm._v("Constantine and the Captive Christians of Persia: Martyrdom and Religious Identity in Late Antiquity.")]), _vm._v(" Oakland: University of California Press, 2019.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Van Rompay, Lucas. “Past and Present Perceptions of Syriac Literary Tradition.” "), _c('em', [_vm._v("Hugoye: Journal of Syriac Studies")]), _vm._v(" 3 (2000): 71–103.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("———. “Syriac Studies: The Challenges of the Coming Decade.” "), _c('em', [_vm._v("Hugoye: Journal of Syriac Studies")]), _vm._v(" 10 (2011): 23–35.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Walker, Joel. "), _c('em', [_vm._v("The Legend of Mar Qardagh: Narrative and Christian Heroism in Late Antique Iraq.")]), _vm._v(" Oakland: University of California Press, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Weitzman, M. P. "), _c('em', [_vm._v("The Syriac Version of the Old Testament")]), _vm._v(". Cambridge: Cambridge University Press, 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Wickes, Jeffrey. "), _c('em', [_vm._v("Bible and Poetry in Late Antique Mesopotamia: Ephrem’s Hymns on Faith")]), _vm._v(". Oakland: University of California Press, 2019.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Wilmshurst, David. "), _c('em', [_vm._v("The Ecclesiastical Organisation of the Church of the East, 1318–1913.")]), _vm._v(" CSCO 582. Leuven: Secrétariat du CSCO, 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item1"
  }, [_vm._v("Wood, Philip. “Syriac and the ‘Syrians.’” Pages 170–94 in "), _c('em', [_vm._v("The Oxford Handbook of Late Antiquity")]), _vm._v(". Edited by Scott Fitzgerald Johnson. Oxford: Oxford University Press, 2012.")]), _vm._v(" "), _c('p', {
    staticClass: "image-f"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-1",
      "id": "foot_1"
    }
  }, [_vm._v("1")]), _vm._v(". The modern-day location of Edessa is Urfa (or Şanilurfa), in southern Turkey, not far from the Syrian border. See Thomas A. Carlson et al., “Edessa,” in "), _c('em', [_vm._v("The Syriac Gazetteer")]), _vm._v(" (online at "), _c('a', {
    attrs: {
      "href": "https://www.syriaca.org/place/78",
      "target": "_blank"
    }
  }, [_vm._v("https://www.syriaca.org/place/78")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-2",
      "id": "foot_2"
    }
  }, [_vm._v("2")]), _vm._v(". For more on Edessa’s religious context, see H. J. W. Drijvers, "), _c('em', [_vm._v("Cults and Beliefs at Edessa")]), _vm._v(" (Leiden: Brill, 1980).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-3",
      "id": "foot_3"
    }
  }, [_vm._v("3")]), _vm._v(". The "), _c('em', [_vm._v("Doctrina Addai")]), _vm._v(", excerpts of which are included in this volume, provides one of the crucial—albeit inflated—accounts of the arrival of Christianity in Edessa. For a general introduction, see Amir Harrak, “Was Edessa or Adiabene the Gateway for the Christianization of Mesopotamia?,” in "), _c('em', [_vm._v("The Levant: Crossroads of Late Antiquity: History, Religion, and Architecture")]), _vm._v(", ed. Ellen Bradshaw Aitken and John M. Fossey (Leiden: Brill, 2014), 165–80.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-4",
      "id": "foot_4"
    }
  }, [_vm._v("4")]), _vm._v(". For a description of Classical Syriac, see Aaron Michael Butts, “The Classical Syriac Language,” in "), _c('em', [_vm._v("The Syriac World")]), _vm._v(", ed. Dan King (London: Routledge, 2019), 222–42; and Butts, “Syriac Language,” in "), _c('em', [_vm._v("GEDSH")]), _vm._v(", 390–91.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-5",
      "id": "foot_5"
    }
  }, [_vm._v("5")]), _vm._v(". For a collection of primary source documents pertaining to this event, situated within the broader context of the fourth-century Roman-Persian wars, see Michael H. Dodgeon and Samuel N. C. Lieu, eds., "), _c('em', [_vm._v("The Roman Eastern Frontier and the Persian Wars, AD 226–363: A Documentary History")]), _vm._v(" (London: Routledge, 1991), 201–36.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-6",
      "id": "foot_6"
    }
  }, [_vm._v("6")]), _vm._v(". One of the best general introductions to Ephrem the Syrian is Sebastian P. Brock, "), _c('em', [_vm._v("The Luminous Eye: The Spiritual World Vision of Saint Ephrem the Syrian")]), _vm._v(" (Collegeville, MN: Cistercian, 1992); see also Jeffrey Wickes, "), _c('em', [_vm._v("Bible and Poetry in Late Antique Mesopotamia: Ephrem’s Hymns on Faith")]), _vm._v(" (Oakland: University of California Press, 2019); and Kathleen McVey, "), _c('em', [_vm._v("Ephrem the Syrian: Hymns")]), _vm._v(" (New York: Paulist, 1989).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-7",
      "id": "foot_7"
    }
  }, [_vm._v("7")]), _vm._v(". Ephrem’s works were collected into cycles of thematically similar content and preserved as collections such as "), _c('em', [_vm._v("Hymns on Faith")]), _vm._v(", "), _c('em', [_vm._v("Hymns on Virginity")]), _vm._v(", "), _c('em', [_vm._v("Hymns on Paradise")]), _vm._v(", and "), _c('em', [_vm._v("Hymns against Julian")]), _vm._v(". The final cycle mentioned here is significant because Ephrem describes in some detail his anger at Julian, both for his attempted revival of the pagan gods and for his actions that resulted in the loss of Nisibis.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-8",
      "id": "foot_8"
    }
  }, [_vm._v("8")]), _vm._v(". Two of Ephrem’s "), _c('em', [_vm._v("Hymns against Heresies")]), _vm._v(" are included in this volume.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-9",
      "id": "foot_9"
    }
  }, [_vm._v("9")]), _vm._v(". For a collection of several examples of this creative exegetical genre in English translation, see Sebastian P. Brock, "), _c('em', [_vm._v("Treasure-house of Mysteries: Explorations of the Sacred Text through Poetry in the Syriac Tradition")]), _vm._v(", Popular Patristics Series 45 (Yonkers, NY: Saint Vladimir’s Seminary Press, 2012); see also Brock, “Syriac Dispute Poems: The Various Types,” in "), _c('em', [_vm._v("Dispute Poems and Dialogues in the Ancient and Medieval Near East: Forms and Types of Literary Debates in Semitic and Related Literatures")]), _vm._v(", ed. G. J. Reinink and H. L. J. Vanstiphout, Orientalia Lovaniensia Analecta 42 (Leuven: Peeters, 1991), 109–19.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-10",
      "id": "foot_10"
    }
  }, [_vm._v("10")]), _vm._v(". For example, see the dialogue of the Canaanite woman in Narsai’s homily and that of Eve in Jacob of Serugh’s homily in this volume.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-11",
      "id": "foot_11"
    }
  }, [_vm._v("11")]), _vm._v(". See Susan Ashbrook Harvey, “Singing Women’s Stories in Syriac Tradition,” "), _c('em', [_vm._v("Internationale kirchliche Zeitschrift")]), _vm._v(" 100 (2010): 171–89; Harvey, “2000 NAPS Presidential Address: Spoken Words, Voiced Silence: Biblical Women in Syriac Tradition,” "), _c('em', [_vm._v("Journal of Early Christian Studies")]), _vm._v(" 9 (2005): 105–31; and Harvey, “Performance as Exegesis: Women’s Liturgical Choirs in Syriac Tradition,” in "), _c('em', [_vm._v("Inquiries into Eastern Christian Worship: Selected Papers of the Second International Congress of the Society of Oriental Liturgy Rome, 17–21 September 2008")]), _vm._v(", ed. Bert Groen, Steven Hawkes-Teeples, and Stefanos Alexopoulos, Eastern Christian Studies 12 (Leuven: Peeters, 2012), 47–64.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-12",
      "id": "foot_12"
    }
  }, [_vm._v("12")]), _vm._v(". Philip Michael Forness, "), _c('em', [_vm._v("Preaching Christology in the Roman Near East: A Study of Jacob of Serugh")]), _vm._v(", Oxford Early Christian Studies (Oxford: Oxford University Press, 2018), 23–24.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-13",
      "id": "foot_13"
    }
  }, [_vm._v("13")]), _vm._v(". For a broader survey of the controversy, see Frances M. Young with Andrew Teal, "), _c('em', [_vm._v("From Nicaea to Chalcedon: A Guide to the Literature and Its Background")]), _vm._v(", 2nd ed. (Grand Rapids: Baker Academic, 2010).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-14",
      "id": "foot_14"
    }
  }, [_vm._v("14")]), _vm._v(". For an excellent survey of these issues particularly relating to the Syriac context, see Sebastian P. Brock, “The ‘Nestorian’ Church: A Lamentable Misnomer,” "), _c('em', [_vm._v("Bulletin of the John Rylands University Library of Manchester")]), _vm._v(" 78 (1996): 23–35. For a collection of primary sources in translation pertaining to Nestorius’s predecessors, Theodore and Diodore, see John Behr, "), _c('em', [_vm._v("The Case against Diodore and Theodore: Texts and Their Contexts")]), _vm._v(" (Oxford: Oxford University Press, 2011).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-15",
      "id": "foot_15"
    }
  }, [_vm._v("15")]), _vm._v(". For the full acts of the Council of Chalcedon with helpful commentary and context, see "), _c('em', [_vm._v("The Acts of the Council of Chalcedon")]), _vm._v(", ed. Richard Price and Michael Gaddis, Translated Texts for Historians 45 (Liverpool: Liverpool University Press, 2005).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-16",
      "id": "foot_16"
    }
  }, [_vm._v("16")]), _vm._v(". Although the terms “monophysite” and “miaphysite” are confused and used interchangeably, they are actually two distinct positions, with the former referring to the unique expression of Eutyches of Constantinople, who argued that the human and divine natures "), _c('em', [_vm._v("combined")]), _vm._v(" to create a new, distinct nature (hence "), _c('em', [_vm._v("mono")]), _vm._v("-, meaning not just “one,” but “unique, only”). The distinction, then, is that miaphysites argued for an indivisible union of natures, whereas the monophysite position represented a mixture of the natures.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-17",
      "id": "foot_17"
    }
  }, [_vm._v("17")]), _vm._v(". The term “Melkite” comes from the Semitic root "), _c('em', [_vm._v("mlk")]), _vm._v(" (noun “king”; verb “to rule”); thus, the Melkites were those who were loyal to the Roman king through their support of Chalcedonian theology. Melkites are also known as Arab Orthodox, Rūm Orthodox, or Antiochian Orthodox. For a collection of translated texts from this tradition, see Samuel Noble and Alexander Treiger, "), _c('em', [_vm._v("The Orthodox Church in the Arab World, 700–1700: An Anthology of Sources")]), _vm._v(" (Dekalb: Northern Illinois University Press, 2014).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-18",
      "id": "foot_18"
    }
  }, [_vm._v("18")]), _vm._v(". See Joseph P. Amar, “Maronite Church,” in "), _c('em', [_vm._v("GEDSH")]), _vm._v(", 270–71; and Shafiq Abouzayd, “The Maronite Church,” in "), _c('em', [_vm._v("The Syriac World")]), _vm._v(", ed. Dan King (London: Routledge, 2019), 731–50.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-19",
      "id": "foot_19"
    }
  }, [_vm._v("19")]), _vm._v(". For one example of such a text, see the "), _c('em', [_vm._v("Martyrdom of Mīles")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-20",
      "id": "foot_20"
    }
  }, [_vm._v("20")]), _vm._v(". For a recent assessment of the persecution associated with Shapur II, see Kyle Smith, "), _c('em', [_vm._v("Constantine and the Captive Christians of Persia: Martyrdom and Religious Identity in Late Antiquity")]), _vm._v(" (Oakland: University of California Press, 2019).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-21",
      "id": "foot_21"
    }
  }, [_vm._v("21")]), _vm._v(". See Volker L. Menze, "), _c('em', [_vm._v("Justinian and the Making of the Syrian Orthodox Church")]), _vm._v(", Oxford Early Christian Studies (Oxford: Oxford University Press, 2008).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-22",
      "id": "foot_22"
    }
  }, [_vm._v("22")]), _vm._v(". For a treatment of the ways that Syriac Christians negotiated their identities in the Persian context, see Richard E. Payne, "), _c('em', [_vm._v("A State of Mixture: Christians, Zoroastrians, and Iranian Political Culture in Late Antiquity")]), _vm._v(" (Oakland: University of California Press, 2015).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-23",
      "id": "foot_23"
    }
  }, [_vm._v("23")]), _vm._v(". Marcia C. Cassis, “Seleucia-Ctesiphon,” "), _c('em', [_vm._v("GEDSH")]), _vm._v(", 365.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-24",
      "id": "foot_24"
    }
  }, [_vm._v("24")]), _vm._v(". For a short introduction, see Sebastian P. Brock, “Greek, Syriac translations from,” in "), _c('em', [_vm._v("GEDSH")]), _vm._v(", 180–81.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-25",
      "id": "foot_25"
    }
  }, [_vm._v("25")]), _vm._v(". One intriguing product of the encounter between the Syriac and Arabic languages is the practice of writing Arabic-language texts in Syriac script, also known as Arabic Garshuni, which is attested in thousands of manuscripts from the Middle East.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-26",
      "id": "foot_26"
    }
  }, [_vm._v("26")]), _vm._v(". For more on Jews and Christians in Syriac literature, see Aaron M. Butts and Simcha Gross, "), _c('em', [_vm._v("Jews and Syriac Christians: Intersections across the First Millennium")]), _vm._v(", Texts and Studies in Ancient Judaism 180 (Tübingen: Mohr Siebeck, 2020).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-27",
      "id": "foot_27"
    }
  }, [_vm._v("27")]), _vm._v(". An excerpt of one such text, by Theodore bar Koni, is translated in this volume. Many other texts are published in Michael Philip Penn, "), _c('em', [_vm._v("When Christians First Met Muslims: A Sourcebook of the Earliest Syriac Writings on Islam")]), _vm._v(" (Oakland: University of California Press, 2015). For more on Syriac Christians and Islam, see Penn, "), _c('em', [_vm._v("Envisioning Islam: Syriac Christians and the Early Muslim World")]), _vm._v(" (Philadelphia: University of Pennsylvania Press, 2017); and Sidney H. Griffith, "), _c('em', [_vm._v("The Church in the Shadow of the Mosque: Christians and Muslims in the World of Islam")]), _vm._v(" (Princeton: Princeton University Press, 2012).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-28",
      "id": "foot_28"
    }
  }, [_vm._v("28")]), _vm._v(". The classic work on this topic is Arthur Vööbus, "), _c('em', [_vm._v("A History of Asceticism in the Syrian Orient: A Contribution to the History of Culture in the Near East")]), _vm._v(", 3 vols., CSCO 184, 197, 500 (Leuven: Secrétariat du CSCO, 1958, 1960, 1988).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-29",
      "id": "foot_29"
    }
  }, [_vm._v("29")]), _vm._v(". Aphrahat, “Demonstration 6: On the Bnay Qyama,” in Adam Lehto, "), _c('em', [_vm._v("The Demonstrations of Aphrahat, the Persian Sage")]), _vm._v(", Gorgias Eastern Christian Studies 27 (Piscataway, NJ: Gorgias, 2010), 169–98.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-30",
      "id": "foot_30"
    }
  }, [_vm._v("30")]), _vm._v(". For more description and bibliography, see Robert A. Kitchen, “Bnay Qyāmā, Bnāt Qyāmā,” in "), _c('em', [_vm._v("GEDSH")]), _vm._v(", 84–85.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-31",
      "id": "foot_31"
    }
  }, [_vm._v("31")]), _vm._v(". Such as the "), _c('em', [_vm._v("Life of Mary of Egypt")]), _vm._v(" included in this volume.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-32",
      "id": "foot_32"
    }
  }, [_vm._v("32")]), _vm._v(". For a comprehensive resource on Syriac hagiography, see "), _c('em', [_vm._v("Qadishe: Guide to the Syriac Saints")]), _vm._v(", ed. Jeanne-Nicole Mellon Saint-Laurent and David A. Michelson (online at "), _c('a', {
    attrs: {
      "href": "https://www.syriaca.org/q/index.html",
      "target": "_blank"
    }
  }, [_vm._v("https://www.syriaca.org/q/index.html")]), _vm._v("); see also Mellon Saint-Laurent, “Syriac Hagiographic Literature,” in "), _c('em', [_vm._v("The Syriac World")]), _vm._v(", ed. Dan King (London: Routledge, 2019), 339–54.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-33",
      "id": "foot_33"
    }
  }, [_vm._v("33")]), _vm._v(". The best introduction to the Bible in Syriac is Sebastian P. Brock, "), _c('em', [_vm._v("The Bible in the Syriac Tradition")]), _vm._v(", Gorgias Handbooks 7 (Piscataway, NJ: Gorgias, 2006).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-34",
      "id": "foot_34"
    }
  }, [_vm._v("34")]), _vm._v(". The translations of the Peshi"), _c('span', {
    staticClass: "f2"
  }, [_vm._v("ṭ")]), _vm._v("ta Old Testament and Peshi"), _c('span', {
    staticClass: "f2"
  }, [_vm._v("ṭ")]), _vm._v("ta New Testament were distinct translation projects; they just came to circulate together as “the Peshi"), _c('span', {
    staticClass: "f2"
  }, [_vm._v("ṭ")]), _vm._v("ta” version.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-35",
      "id": "foot_35"
    }
  }, [_vm._v("35")]), _vm._v(". It is still quite common to find Syriac biblical manuscripts that lacked these books, even long after they were translated into Syriac.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-36",
      "id": "foot_36"
    }
  }, [_vm._v("36")]), _vm._v(". For a short introduction, see Sebastian P. Brock, “Aspects of Translation Technique in Antiquity,” "), _c('em', [_vm._v("Greek, Roman, and Byzantine Studies")]), _vm._v(" 20 (1979): 69–87, reprinted in Brock’s "), _c('em', [_vm._v("Syriac Perspectives on Late Antiquity")]), _vm._v(" (Aldershot, UK: Ashgate Variorum, 2001).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-37",
      "id": "foot_37"
    }
  }, [_vm._v("37")]), _vm._v(". For more on the Philoxenian revision, see J. Edward Walters, “The Philoxenian Gospels as Reconstructed from the Writings of Philoxenos of Mabbug,” "), _c('em', [_vm._v("Hugoye: Journal of Syriac Studies")]), _vm._v(" 13 (2010): 177–249. See also George A. Kiraz, "), _c('em', [_vm._v("Comparative Edition of the Syriac Gospels: Aligning the Sinaiticus, Curetonianus, Peshitta, and Harklean Versions")]), _vm._v(" (Piscataway, NJ: Gorgias, 2004).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-38",
      "id": "foot_38"
    }
  }, [_vm._v("38")]), _vm._v(". See Muriel Debié, Alain Desreumaux, Christelle Jullien, and Florence Jullien, eds., "), _c('em', [_vm._v("Les apocryphes syriaques")]), _vm._v(", Études syriaques 2 (Paris: Geuthner, 2005).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-39",
      "id": "foot_39"
    }
  }, [_vm._v("39")]), _vm._v(". Tony Burke, "), _c('em', [_vm._v("The Infancy Gospel of Thomas in the Syriac Tradition")]), _vm._v(", Gorgias Eastern Christian Studies 48 (Piscataway, NJ: Gorgias, 2017).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-40",
      "id": "foot_40"
    }
  }, [_vm._v("40")]), _vm._v(". For an interesting historical note on the Syro-Hexapla in Syriac, see the translation of Timothy I’s "), _c('em', [_vm._v("Letter 47")]), _vm._v(" in this volume.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-41",
      "id": "foot_41"
    }
  }, [_vm._v("41")]), _vm._v(". Herman G. B. Teule, “Renaissance, Syriac,” in "), _c('em', [_vm._v("GEDSH")]), _vm._v(", 350–51.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-42",
      "id": "foot_42"
    }
  }, [_vm._v("42")]), _vm._v(". The latter is also frequently known as simply Barhebraeus or by his Arabic name Grigorios Abū al-Faraj.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-43",
      "id": "foot_43"
    }
  }, [_vm._v("43")]), _vm._v(". See Dorothea Weltecke, “Michael I Rabo,” in "), _c('em', [_vm._v("GEDSH")]), _vm._v(", 287–90.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-44",
      "id": "foot_44"
    }
  }, [_vm._v("44")]), _vm._v(". See Hidemi Takahashi, “Bar "), _c('span', {
    staticClass: "f2"
  }, [_vm._v("ʿ")]), _vm._v("Ebroyo, Grigorios,” in "), _c('em', [_vm._v("GEDSH")]), _vm._v(", 54–56.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-45",
      "id": "foot_45"
    }
  }, [_vm._v("45")]), _vm._v(". Though, as Adam Becker argues, there is some question about the existence of a “school” of Edessa, as all of the sources for this school are from a later period; Becker, “Edessa, School of,” "), _c('em', [_vm._v("GEDSH")]), _vm._v(", 139–40.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-46",
      "id": "foot_46"
    }
  }, [_vm._v("46")]), _vm._v(". For a brief introduction, see Adam Becker, “Nisibis, School of,” "), _c('em', [_vm._v("GEDSH")]), _vm._v(", 311–12; see also Becker, "), _c('em', [_vm._v("Fear of God and the Beginning of Wisdom: The School of Nisibis and Christian Scholastic Culture in Late Antique Mesopotamia")]), _vm._v(" (Philadelphia: University of Pennsylvania Press, 2006); and Becker, "), _c('em', [_vm._v("Sources for the Study of the School of Nisibis")]), _vm._v(", Translated Texts for Historians 50 (Liverpool: Liverpool University Press, 2008).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-47",
      "id": "foot_47"
    }
  }, [_vm._v("47")]), _vm._v(". Images of manuscripts from these important locations, and many others, have been digitized and are available for viewing through the Hill Museum & Manuscript Library.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-48",
      "id": "foot_48"
    }
  }, [_vm._v("48")]), _vm._v(". For more information, see Monica J. Blanchard, “Moses of Nisibis (fl. 906–943) and the Library of Deir Suriani,” in "), _c('em', [_vm._v("Studies in the Christian East in Memory of Mirrit Boutros Ghali")]), _vm._v(", ed. Leslie S. B. MacCoull (Washington, DC: Society for Coptic Archaeology, 1995); and Sebastian P. Brock, “Without Mushê of Nisibis, Where Would We Be?: Some Reflections on the Transmission of Syriac Literature,” "), _c('em', [_vm._v("Journal of Eastern Christian Studies")]), _vm._v(" 56.1–4 (2004): 15–24.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-49",
      "id": "foot_49"
    }
  }, [_vm._v("49")]), _vm._v(". The Syriac apocryphal work known as the "), _c('em', [_vm._v("Acts of Thomas")]), _vm._v(" places the origins of Christianity in India in the first century with the arrival of the apostle Judas Thomas. For more on the spread of Syriac Christianity into central Asia and China, see Mark Dickens, “Syriac Christianity in Central Asia,” and Hidemi Takahashi, “Syriac Christianity in China,” both in "), _c('em', [_vm._v("The Syriac World")]), _vm._v(", ed. Dan King (London: Routledge, 2019), 583–623, 624–52.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-50",
      "id": "foot_50"
    }
  }, [_vm._v("50")]), _vm._v(". A very accessible and thorough treatment of this topic is István Perczel, “Syriac Christianity in India,” in "), _c('em', [_vm._v("The Syriac World")]), _vm._v(", ed. Dan King (London: Routledge, 2019), 653–97.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot-51",
      "id": "foot_51"
    }
  }, [_vm._v("51")]), _vm._v(". For a brief introduction, see Sebastian P. Brock, “Sayfo,” in "), _c('em', [_vm._v("GEDSH")]), _vm._v(", 361.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a235dfd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/010_Chapter01.vue
// module id = 84
// module chunks = 0